import type { IAsset } from '../../../../interfaces/asset';
import type { ICustomControlProcedureReadProps } from '../../interfaces/';
import { translateKey } from '../../../../../translate';
import { FormGroup } from '../../../../elements/forms/FormGroup';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { ProcedureAssetThumbnails } from '../../../episodes/common';

export function ProcedureThumbnails(props: ICustomControlProcedureReadProps) {
    let procedureFiles: IAsset[] = [];
    if (Array.isArray(props.procedure.assets)) {
        procedureFiles = procedureFiles.concat(props.procedure.assets);
    }

    if (props.procedure.customControlData && Array.isArray(props.procedure.customControlData.files)) {
        const newProcedureFiles = props.procedure.customControlData.files.filter(
            (file: IAsset) => !procedureFiles.find((item) => item.id === file.id)
        );
        procedureFiles = procedureFiles.concat(newProcedureFiles);
    }

    if (procedureFiles.length > 0) {
        return (
            <FormGroup>
                <FormLabel>{translateKey('request.attachment')}: </FormLabel>
                <ProcedureAssetThumbnails
                    assets={procedureFiles}
                    procedureId={props.procedure.id}
                />
            </FormGroup>
        );
    }

    return null;
}
